<template>
    <div class="cart-promocode gray-block">
        <div class="q-pb-md">
            <div class="q-pb-sm">
                <q-radio
                    id="bonus-accumulation"
                    v-model="bonusType"
                    :val="1"
                    :label="accumulationLabel"/>
            </div>
            <div v-if="availableBonusAmount > 0">
                <q-radio
                    id="bonus-write-off"
                    v-model="bonusType"
                    :val="2"
                    :label="'Списать баллы: ' + bonusWriteOff + ' балл(а,ов) (' + availableBonusAmount + ' доступно)'"/>

                <q-input outlined
                         dense
                         v-if="false && (bonusType === 'write-off')"
                         v-model="bonusWriteOff"
                         :error-message="false"
                         :error="false">
<!--                    @keydown="promoCodeForm.errors.clear('promo_code')"-->
<!--                    <template v-slot:after>-->
<!--                        <q-btn outline label="Применить" @click.prevent="applyPromoCode"/>-->
<!--                    </template>-->
                </q-input>
            </div>

            <div v-if="!logged" class="q-mt-md">
                Для списания балов, необходимо войти в
                <a href="#" class="text-primary" @click.prevent="showModal">Личный кабинет</a>.
            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters, mapMutations} from "vuex";

export default {
    name: 'CartBonus',
    data () {
        return {
            bonusTypes: [
                'accumulation',
                'write-off'
            ],
        }
    },
    mounted () {
        this.setWriteOff();
    },
    methods: {
        ...mapMutations('cart', [
            'setWriteOff',
        ]),
        ...mapMutations('auth', [
            'showModal'
        ])
        /*setWriteOff() {
            this.bonusWriteOff = this.availableBonusAmount > this.maxBonusWriteOff
                ? this.maxBonusWriteOff
                : this.availableBonusAmount;
        }*/
    },
    watch: {
        totalPrice(newValue, oldValue) {
            this.setWriteOff();
        },
        bonusType(newValue) {
            this.setWriteOff();

            this.$store.dispatch('cart/changeBonusType');
        },
    },
    computed: {
        ...mapState('auth', [
            'logged',
        ]),
        ...mapState('cart', [
            'bonusAccumulationPercentage',
            'maxBonusWriteOffPercentage',
            'availableBonusAmount',
            'items',
            'itemsCount'
        ]),
        ...mapGetters('cart', [
            'totalPrice',
            'bonusAccumulationAmount'
        ]),
        bonusType: {
            get () {
                return this.$store.state.cart.form.bonus_movement_type_id;
            },
            set (value) {
                this.$store.commit('cart/setFormValue', {
                    key: 'bonus_movement_type_id',
                    value: value
                });
            }
        },
        bonusWriteOff: {
            get () {
                return this.$store.state.cart.form.bonus_write_off;
            },
            set (value) {
                this.$store.commit('cart/setBonusWriteOff', value);
            }
        },
        /*maxBonusWriteOff () {
            return this.items.reduce((sum, item) =>
                sum + (Math.floor(item.product.step_price * this.maxBonusWriteOffPercentage / 100) * item.quantity), 0);
        },*/
        accumulationLabel () {
            return 'Накопление: ' + this.bonusAccumulationAmount + ' балл(а,ов)'
        }
    }
}
</script>
